import { useState } from 'react';
import Text from '../../../atoms/Text';

import './styles.scss';

export type FaqTableRow = {
  question: string;
  answear: string;
};

interface IFaqTableProps {
  rows: FaqTableRow[];
}

const FaqTable = ({ rows }: IFaqTableProps) => {
  return (
    <div className='faq_table'>
      {rows.map((row, index) => (
        <Row key={index} row={row} last={index === rows.length - 1} />
      ))}
    </div>
  );
};

interface IRowProps {
  row: FaqTableRow;
  last: boolean;
}
const Row = ({ row, last }: IRowProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className='faq_table__row'>
        <div className='faq_table__row__question'>
          <Text size={16} className='faq_table__row__question__text'>
            {row.question}
          </Text>
          <div
            className={`faq_table__row__question__icon ${
              isOpen ? 'icon-minus' : 'icon-plus'
            }`}
            onClick={() => setIsOpen(!isOpen)}
          />
        </div>
        {isOpen && (
          <Text size={14} className='faq_table__row__answear'>
            {row.answear}
          </Text>
        )}
      </div>
      {!last && <div className='faq_table__divider' />}
    </>
  );
};

export default FaqTable;
